import React, { useState, useEffect } from 'react'
import { Button, Modal, Select, message } from 'antd'
import moment from 'moment'
import './settleScaniaPrint.css'
import skny from '../../../assets/images/skny.png'
import ouman from '../../../assets/images/ouman.png'
import zf from '../../../assets/images/zf.png'
import hg from '../../../assets/images/hgLogo.png'
import jd from '../../../assets/images/京东名称.jpg'
import oh from '../../../assets/images/ohLogo.png'
import iveco from '../../../assets/images/iveco.png'
import yhjt from '../../../assets/images/yhjt.png'
import ztyhjt from '../../../assets/images/ztyhjt.png'
import jdLogo from '../../../assets/images/京东logo.jpg'
import { globalPrompt } from '../message'
import { useDictModel } from '../../pages/base/dict/dictModel'
import { saveAs } from 'file-saver'
import { getUserCustomizeConfigOne, saveUserCustomizeConfig } from "@/service/settings"
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { orderPrintInfo, printNum, getOrderOne } from "@/service/ordersService"
import { IS_TEST } from '../../../config/app'

const ExcelJS = require('exceljs')

//打印logo设置
export const IIMgEmum = {
    SKNY: 'skny',
    OUMAN: 'ouman',
    ZF: 'zf',
    IVECO: 'iveco',
    OH: 'oh',
    HG: 'hg',
    JD: 'jd',
}
export const logoOptions = [
    { label: '斯堪尼亚logo', value: IIMgEmum.SKNY },
    { label: '依维柯logo', value: IIMgEmum.IVECO },
    { label: '曼恩logo', value: IIMgEmum.OUMAN },
    { label: '采埃孚logo', value: IIMgEmum.ZF },
    { label: '欧辉logo', value: IIMgEmum.OH },
    { label: '海格logo', value: IIMgEmum.HG },
    { label: '京东logo', value: IIMgEmum.JD },
]

let shopObject = {
    "SHOP-M-00000017": {
        "img": skny,
        "address": "新疆乌鲁木齐市米东区金汇西路2877号",
        "phone": "0991-5310666     18016861905",
        "Bank": "招商银行乌鲁木齐分行解放北路支行",
        "BankAccount": "8530 8058 0110 001",
        "Fax": "0991-5310666     18016861905"
    },
    "SHOP-M-00000018": {
        "img": ouman,
        "phone": "0991-5310666     13209963230",
        "Bank": "新疆天山农村银行股份有限公司米东区支行",
        "BankAccount": "8070 1001 2010 1140 42179",
        "Fax": "0991-5310666     13209963230"
    },
    "SHOP-M-00000020": {
        "img": skny,
        "address": "天津津南经济开发区 旺港路15号",
        "phone": "022-28577398",
        "Bank": "中国工商银行股份有限公司天津金地支行",
        "BankAccount": "0302061609100023871",
        "Fax": "022-28577392"
    },
    "SHOP-M-00000019": {
        "img": skny,
        "address": "辽宁省沈阳市于洪区旺港街201号13门",
        "phone": "18600830027",
        "Bank": "中国工商银行股份有限公司沈阳于洪支行",
        "BankAccount": "3301009209200071238",
        "Fax": ""
    },
    "SHOP-M-00000016": {
        "img": skny,
        "address": "河北省石家庄市无极县经济技术开发区西区泰智产业园14幢3-4座",
        "phone": "0311-88036200  ",
        "Bank": "中国工商银行股份有限公司栾城支行",
        "BankAccount": "0402020709300237638",
        "Fax": ""
    },
    "SHOP-M-00000021": {
        "img": skny,
        "address": "北京市大兴区长子营镇长通路4号",
        "phone": "010-81280170",
        "Bank": "工行北京沙河支行",
        "BankAccount": "0200 0117 0900 6770 729",
        "Fax": "010-81280170"
    },
    "SHOP-M-00000029": {
        "img": skny,
        "address": "北京市大兴区长子营镇长通路4号",
        "phone": "010-81280170",
        "Bank": "工行北京沙河支行",
        "BankAccount": "0200 0117 0900 6770 729",
        "Fax": "010-81280170"
    },
}

// 从localStorage获取实体显示状态的函数
const getStoredShowEntity = () => {
    try {
        const stored = localStorage.getItem('settleScaniaPrint_showEntity');
        return stored ? JSON.parse(stored) : true;
    } catch (error) {
        console.error('Failed to get stored showEntity:', error);
        return true;
    }
};

// 存储实体显示状态到localStorage的函数
const setStoredShowEntity = (value) => {
    try {
        localStorage.setItem('settleScaniaPrint_showEntity', JSON.stringify(value));
    } catch (error) {
        console.error('Failed to store showEntity:', error);
    }
};

export const SettleScaniaPrint = ({
    title = '',
    visible,
    onClose,
    columns,
    itemClumns,
    itemDataSource,
    dataSource,
    formVal,
    isTechnician = false,
    price,
    baseInfo,
    otherClumns,
    otherDataSource,
    onPrint,
}) => {
    const { getTreeNodeName, getTreeNodeOne } = useDictModel()
    const { user: { shopCode, orgShopCode }, setMaterialInfo } = useGlobalModel();
    const [showEntity, setShowEntity] = useState(true) // 控制是否显示实体名称
    const [imgVal, setImgVal] = useState(shopCode == 'SHOP-M-00000104' ? jd : skny)

    // 组件挂载时从localStorage读取实体显示状态
    useEffect(() => {
        if (visible) {
            const storedShowEntity = getStoredShowEntity();
            setShowEntity(storedShowEntity);
        }
    }, [visible]);

    // 设置实体名称显示状态的方法
    const setStName = () => {
        let entityVal = showEntity
        globalPrompt('modal', {
            width: 450,
            title: '设置实体显示',
            type: 'info',
            text: (
                <>
                    <span style={{ fontSize: 17 }}>请选择是否显示实体名称</span>
                    <Select
                        style={{ marginLeft: 5 }}
                        showSearch={true}
                        value={entityVal}
                        options={[
                            { label: '显示实体', value: true },
                            { label: '不显示实体', value: false }
                        ]}
                        onChange={(value) => (entityVal = value)}
                    />
                </>
            ),
            okText: '确定',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    resolve(entityVal)
                }).then((res) => {
                    setShowEntity(res)
                    setStoredShowEntity(res); // 存储到localStorage
                    message.success('设置成功')
                })
            },
            cancelText: '取消',
            onCancel: () => { },
        })
    }

    // 遍历商品td
    const mapGoods = (goods) => {
        return columns
            .filter((item) => item)
            .map((item, index) => (
                <td colSpan={item.colSpan ?? 1} key={index}>
                    {item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}
                </td>
            ))
    }

    //遍历项目td
    const itemGoods = (goods) => {
        return itemClumns
            ?.filter((item) => item)
            .map((item, index) => (
                <td colSpan={item.colSpan ?? 1} key={index}>
                    {item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}
                </td>
            ))
    }

    //遍其他项目td
    const otherGoods = (goods) => {
        return otherClumns
            ?.filter((item) => item)
            .map((item, index) => (
                <td colSpan={item.colSpan ?? 1} key={index}>
                    {item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}
                </td>
            ))
    }

    const convertImageToBase64 = (imageUrl) => {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.crossOrigin = 'Anonymous'
            img.onload = () => {
                const canvas = document.createElement('canvas')
                canvas.width = img.width
                canvas.height = img.height
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0)

                const base64 = canvas.toDataURL('image/png')
                resolve(base64)
            }
            img.onerror = () => {
                reject(new Error('Failed to load image'))
            }
            img.src = imageUrl
        })
    }

    const getItemColumns = () => {
        return itemClumns.map((item) => {
            return item.title
        }).slice(0, 7)
    }

    const getItemDataSource = () => {
        if (!itemDataSource || itemDataSource.length <= 0) {
            return []
        }

        let itemDataIndexList = itemClumns.map((item) => {
            return item.dataIndex
        })
        return itemDataSource.map((item) => {
            let arr = []
            itemDataIndexList.forEach((dataIndex) => {
                let val = item[dataIndex]
                arr.push(val)
            })
            return arr.slice(0, 7)
        })
    }

    const getMaterialColumns = () => {
        return columns.map((item) => {
            return item.title
        }).slice(0, 7)
    }

    const getMaterialDataSource = () => {
        if (!dataSource || dataSource.length <= 0) {
            return []
        }

        let itemDataIndexList = columns.map((item) => {
            return item.dataIndex
        })
        return dataSource.map((item) => {
            let arr = []
            itemDataIndexList.forEach((dataIndex) => {
                let val = item[dataIndex]
                arr.push(val)
            })
            return arr.slice(0, 7)
        })
    }

    const getOtherColumns = () => {
        return otherClumns.map((item) => {
            return item.title
        })
    }

    const getOtherDataSource = () => {
        if (!otherDataSource || otherDataSource.length <= 0) {
            return []
        }

        let itemDataIndexList = otherClumns.map((item) => {
            return item.dataIndex
        })
        return otherDataSource.map((item) => {
            let arr = []
            itemDataIndexList.forEach((dataIndex) => {
                let val = item[dataIndex]
                arr.push(val)
            })
            return arr
        })
    }

    const printExport = async () => {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Sheet1')
        worksheet.properties.defaultRowHeight = 25
        worksheet.properties.defaultColWidth = 15

        let base64Data = await convertImageToBase64(skny)
        const logoImgId = workbook.addImage({ base64: base64Data, extension: 'png' })

        worksheet.mergeCells('A1:G1')
        worksheet.getCell('A1').value = '工单详情打印'
        worksheet.addImage(logoImgId, 'A3:A4')

        // 根据showEntity状态决定是否显示实体名称
        worksheet.mergeCells('D2:G2')
        worksheet.mergeCells('D3:G3')
        worksheet.mergeCells('D4:G4')
        worksheet.mergeCells('D5:G5')
        worksheet.mergeCells('D6:G6')
        worksheet.getCell('D2').value = showEntity ? title : '修理结算单'
        worksheet.getCell('D3').value = `地址：${shopObject[shopCode] ? shopObject[shopCode]["address"] : ''}`
        worksheet.getCell('D4').value = `电话：${shopObject[shopCode] ? shopObject[shopCode]["phone"] : ''}`
        worksheet.getCell('D5').value = `开户银行：${shopObject[shopCode] ? shopObject[shopCode]["Bank"] : ''}`
        worksheet.getCell('D6').value = `开户账号：${shopObject[shopCode] ? shopObject[shopCode]["BankAccount"] : ''}`

        // ... 其余Excel导出代码保持不变
        worksheet.mergeCells('A8:C8')
        worksheet.mergeCells('D8:G8')
        worksheet.getCell('A8').value = '委托客户:' + formVal.customerName
        worksheet.getCell('D8').value = '工单号:' + formVal.maintenanceCode

        worksheet.mergeCells('A9:B9')
        worksheet.mergeCells('C9')
        worksheet.mergeCells('D9:G9')
        worksheet.getCell('A9').value = '车牌号:' + formVal.licensePlate
        worksheet.getCell('C9').value = '底盘号:' + formVal.vin
        worksheet.getCell('D9').value = '预约进厂时间:' + formVal.enterTime

        worksheet.mergeCells('A10:B10')
        worksheet.mergeCells('C10')
        worksheet.mergeCells('D10:G10')
        worksheet.getCell('A10').value = '送修人:' + formVal.contact
        worksheet.getCell('C10').value = '联系电话:' + formVal.phone
        worksheet.getCell('D10').value = '预约出厂时间:' + formVal.deliveryTime

        worksheet.mergeCells('A11:B11')
        worksheet.mergeCells('C11')
        worksheet.mergeCells('D11:G11')
        worksheet.getCell('A11').value = '维修类型:' + formVal.serviceTypeName
        worksheet.getCell('C11').value = '车辆类型:' + formVal.vehicleTypeName
        worksheet.getCell('D11').value = '行驶里程/工作时间:' + formVal.mileage

        worksheet.mergeCells('A12:G12')
        worksheet.getCell('A12').value = '故障描述:' + formVal.faultDesc

        worksheet.mergeCells('A13:G13')
        worksheet.getCell('A13').value = '原因分析和处理意见:' + formVal.faultResult

        if (itemClumns && itemDataSource && itemDataSource.length > 0) {
            let itemExcelColumns = getItemColumns()
            let itemExcelDataSource = getItemDataSource()
            worksheet.addRow(itemExcelColumns)
            worksheet.addRows(itemExcelDataSource)
        }
        if (columns && dataSource && dataSource.length > 0) {
            let materialExcelColumns = getMaterialColumns()
            let materialExcelDataSource = getMaterialDataSource()
            worksheet.addRow(materialExcelColumns)
            worksheet.addRows(materialExcelDataSource)
        }
        if (otherClumns && otherDataSource && otherDataSource.length) {
            let otherExcelColumns = getOtherColumns()
            let otherExcelDataSource = getOtherDataSource()
            worksheet.addRow(otherExcelColumns)
            worksheet.addRows(otherExcelDataSource)
        }

        let itemRow = itemDataSource.length > 0 ? 1 + itemDataSource.length : 0;
        let materialRow = dataSource.length > 0 ? 1 + dataSource.length : 0;
        let otherRow = otherDataSource.length > 0 ? 1 + otherDataSource.length : 0;
        let rowCount = itemRow + materialRow + otherRow + 14;

        const secondCell1 = worksheet.getCell(`A${rowCount}`);
        worksheet.mergeCells(`A${rowCount}:G${rowCount}`)
        secondCell1.value = '零件小计：' + price.materialScienceAmount
        secondCell1.alignment = { horizontal: 'right' };

        const secondCell2 = worksheet.getCell(`A${rowCount + 1}`);
        worksheet.mergeCells(`A${rowCount + 1}:G${rowCount + 1}`)
        secondCell2.value = '总合计：' + price.totalAmount
        secondCell2.alignment = { horizontal: 'right' };

        const secondCell3 = worksheet.getCell(`A${rowCount + 2}`);
        worksheet.mergeCells(`A${rowCount + 2}:G${rowCount + 2}`)
        secondCell3.value = '备注：' + formVal.remark

        const secondCell4 = worksheet.getCell(`A${rowCount + 3}`);
        worksheet.mergeCells(`A${rowCount + 3}:G${rowCount + 3}`)
        secondCell4.value = '制单员：' + formVal.createUserName

        const secondCell5 = worksheet.getCell(`A${rowCount + 4}`);
        worksheet.mergeCells(`A${rowCount + 4}:G${rowCount + 5}`)
        secondCell5.value = '声明 1.本人同意按贵厂工单所列的修理项目修理，愿意支付有关项目需要更换的零件款及修理费 2.车辆翻新，拆装前后挡风玻璃，如有损坏，我厂概不赔偿 3.车主提车时，请对我厂修理项目，车况检查清楚，出厂后概不负责'
        secondCell5.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };

        const secondCell6 = worksheet.getCell(`A${rowCount + 6}`);
        worksheet.mergeCells(`A${rowCount + 6}:G${rowCount + 6}`)
        secondCell6.value = '委托人：'

        workbook.xlsx.writeBuffer().then((buffer) => {
            let blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
            saveAs(blob, '工单打印.xlsx')
        })
    }

    const print = async () => {
        const el = document.getElementById('settle-scania-print-container')
        const iframe = document.createElement('IFRAME')
        let doc = null
        document.body.appendChild(iframe)
        doc = iframe.contentWindow.document
        doc.write(`<LINK rel="stylesheet" type="text/css" href="./settleScaniaPrint.css">`)
        doc.write(el?.innerHTML)
        doc.close()
        iframe.contentWindow.focus()
        iframe.onload = () => {
            iframe.contentWindow.print()
            document.body.removeChild(iframe)
        }
        if (navigator.userAgent.indexOf('MSIE') > 0) {
            document.body.removeChild(iframe)
        }
        if (onPrint) {
            await onPrint()
        } else {
            await printNum({ orderId: visible.orderId, printType: 'settlement' })
        }
    }

    const setLogo = () => {
        let logoVal = IIMgEmum.SKNY
        globalPrompt('modal', {
            width: 380,
            title: '设置logo',
            type: 'info',
            text: (
                <>
                    <span>请选择Logo类型</span>
                    <Select showSearch={true} defaultValue={IIMgEmum.SKNY} options={logoOptions} onChange={(value, option) => (logoVal = value)} />
                </>
            ),
            okText: '确定',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    resolve(logoVal)
                }).then((res) => {
                    switch (logoVal) {
                        case IIMgEmum.SKNY:
                            return setImgVal(skny)
                        case IIMgEmum.OUMAN:
                            return setImgVal(ouman)
                        case IIMgEmum.ZF:
                            return setImgVal(zf)
                        case IIMgEmum.IVECO:
                            return setImgVal(iveco)
                        case IIMgEmum.OH:
                            return setImgVal(oh)
                        case IIMgEmum.HG:
                            return setImgVal(hg)
                        case IIMgEmum.JD:
                            return setImgVal(jd)
                        default:
                            return setImgVal(skny)
                    }
                })
            },
            cancelText: '取消',
            onCancel: () => { },
        })
    }

    return (
        <Modal
            title="打印详情"
            width={800}
            visible={visible}
            onCancel={onClose}
            bodyStyle={{ padding: '0' }}
            footer={[
                <Button type="primary" onClick={onClose} key="back">
                    取消
                </Button>,
                <Button type="primary" onClick={print} key="submit">
                    确认打印
                </Button>,
                <Button type="primary" onClick={printExport} key="export">
                    导出Excel
                </Button>,
                <Button type="primary" onClick={setLogo} key="logo">
                    设置Logo
                </Button>,
                <Button type="primary" onClick={setStName} key="entity">
                    设置实体
                </Button>,
            ]}
        >
            <div id="settle-scania-print-container" className="pdf-content print-box" style={{ padding: '24px' }}>
                <div className="settle-container">
                    <div className="settle-header">
                        <div className="h2">
                            {/* 根据showEntity状态决定显示实体名称还是只显示"修理结算单" */}
                            {showEntity ? (
                                <h2>{title}修理结算单</h2>
                            ) : (
                                <h2>修理结算单</h2>
                            )}
                        </div>
                        {imgVal == jd ?
                            <div className={`JDlogo `}>
                                <img src={jd} alt="" />
                            </div> :
                            <div className={`logo `}>
                                <img src={IS_TEST ? ztyhjt : yhjt} alt="" />
                            </div>}
                        <div className={`skny`}>
                            {imgVal == jd ? "" : <img src={imgVal} alt="斯堪尼亚" />}
                        </div>
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td>服务厂:</td>
                                <td colSpan={3}>
                                    {/* 根据showEntity状态决定是否显示服务厂名称 */}
                                    {showEntity ? (title ?? '') : <div style={{ height: '20px' }}></div>}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={6}></td>
                            </tr>
                            <tr>
                                <td colSpan={6}></td>
                            </tr>
                            <tr>
                                <td>工单号:</td>
                                <td>{formVal.maintenanceCode}</td>
                                <td>进厂时间:</td>
                                <td>{formVal.enterTime}</td>
                                <td>出厂时间:</td>
                                <td>{formVal.deliveryTime}</td>
                            </tr>
                            <tr>
                                <td>托修单位:</td>
                                <td colSpan={3}>{formVal.customerName}</td>
                                <td>行驶里程:</td>
                                <td>
                                    {formVal.mileage}
                                    <span className="span-right">KM</span>
                                </td>
                            </tr>
                            <tr>
                                <td>联系人:</td>
                                <td>{formVal.contact}</td>
                                <td>联系电话:</td>
                                <td>{formVal.phone}</td>
                                <td>结算方式:</td>
                                <td>{getTreeNodeName(formVal.payType)}</td>
                            </tr>
                            <tr>
                                <td>车辆类型:</td>
                                <td>{formVal.vehicleTypeName}</td>
                                <td>车牌号:</td>
                                <td>{formVal.licensePlate}</td>
                                <td>底盘号:</td>
                                <td>{formVal.vin}</td>
                            </tr>
                            <tr>
                                <td>维修类型:</td>
                                <td>{formVal.serviceTypeName}</td>
                                <td>结算方:</td>
                                <td>{formVal.settlementPartyName}</td>
                                <td>运行小时:</td>
                                <td>{formVal.operatingHours}</td>
                            </tr>
                            <tr className="bottom-solid">
                                <td width="100px">客户地址:</td>
                                <td colSpan={3} style={{ wordBreak: 'break-all' }}>
                                    {formVal.customerAddress}
                                </td>
                            </tr>
                            {isTechnician && (
                                <tr className="bottom-solid">
                                    <td width="100px">维修技师:</td>
                                    <td colSpan={5} style={{ wordBreak: 'break-all' }}>
                                        {formVal.technicianNames}
                                    </td>
                                </tr>
                            )}
                            <tr className="bottom-solid">
                                <td width="100px">故障描述:</td>
                                <td colSpan={5} style={{ wordBreak: 'break-all' }}>
                                    {formVal.faultDesc}
                                </td>
                            </tr>
                            <tr className="bottom-solid">
                                <td width="100px">处理结果:</td>
                                <td colSpan={5} style={{ wordBreak: 'break-all' }}>
                                    {formVal.faultResult}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table className="ming-xi">
                        <tbody>
                            {itemClumns && itemDataSource && itemDataSource.length > 0 && (
                                <tr>
                                    {itemClumns
                                        .filter((item) => item)
                                        .map((item, index) => (
                                            <td key={index}>{item.title}</td>
                                        ))}
                                </tr>
                            )}
                            {itemDataSource && itemDataSource.length > 0 && itemDataSource.map((item, index) => <tr key={index}>{itemGoods(item)}</tr>)}
                            {columns && dataSource && dataSource.length > 0 && (
                                <tr className="part">
                                    {columns
                                        .filter((item) => item)
                                        .map((item, index) => (
                                            <td key={index}>{item.title}</td>
                                        ))}
                                </tr>
                            )}
                            {dataSource && dataSource.length > 0 && dataSource.map((item, index) => <tr key={index}>{mapGoods(item)}</tr>)}
                            {otherClumns && otherDataSource && otherDataSource.length > 0 && (
                                <tr className="part">
                                    {otherClumns
                                        .filter((item) => item)
                                        .map((item, index) => (
                                            <td key={index}>{item.title}</td>
                                        ))}
                                </tr>
                            )}
                            {otherDataSource && otherDataSource.length > 0 && otherDataSource.map((item, index) => <tr key={index}>{otherGoods(item)}</tr>)}
                        </tbody>
                    </table>
                    <div className="total-price">
                        <table>
                            <tbody>
                                <tr>
                                    <td>工时小计</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.workingHoursAmount ?? 0}
                                    </td>
                                </tr>
                                <tr>
                                    <td>零件小计</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.materialScienceAmount}
                                    </td>
                                </tr>
                                <tr>
                                    <td>其他费用</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.otherItemActualAmount}
                                    </td>
                                </tr>
                                <tr>
                                    <td>费用合计</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.orderSummaryAmount}
                                    </td>
                                </tr>
                                <tr>
                                    <td>优惠金额</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.orderPreferentialAmount}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {formVal.payType === 'settle-type.cash' ? '实收' : '应收'}人民币金额(RMB)&nbsp;&nbsp;{formVal.paymentMethodName}
                                    </td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.totalAmount}
                                    </td>
                                </tr>
                                <tr>
                                    <td>大写人民币</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>
                                        {price.receivableTotalAmountCN}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="remarks" style={{ margin: '10px 0 20px' }}>
                        备注：{formVal.remark}
                    </p>
                    <div className="print-flex">
                        <div>
                            制单<span>&nbsp;&nbsp;{formVal.createUserName}</span>
                        </div>
                        <div>
                            库房<span>&nbsp;&nbsp;</span>
                        </div>
                        <div>
                            质检<span>&nbsp;&nbsp;{formVal.formVal}</span>
                        </div>
                        <div>
                            财务<span>&nbsp;&nbsp;{formVal.formVal}</span>
                        </div>
                    </div>
                    <div className={`sign-open`}>
                        <div>托修人签字:</div>
                        <div>维修厂签字:</div>
                    </div>
                    <div className={`warm-reminder`}>
                        <p>预防性更换温馨提示：</p>
                        <p>前轮轴承80万公里，后轮轴承60万公里，离合器分离轴承70万公里</p>
                    </div>
                    <div className="footer">
                        <span> {imgVal == jd ? '北京京鸿物流有限公司大兴分公司' : (showEntity ? title : '')}</span>
                        {imgVal == jd ? <span>联系人：靳经理</span> :
                            <span>
                                地址： <span>{shopObject[shopCode] ? shopObject[shopCode]["address"] : ''}</span>
                            </span>
                        }
                        <span>
                            电话： {imgVal == jd ? '13910025938' : <span>{shopObject[shopCode] ? shopObject[shopCode]["phone"] : ''}</span>}
                        </span>
                    </div>
                    <p style={{ marginTop: '20px', textAlign: 'right' }}>打印日期:&nbsp;&nbsp;&nbsp;{moment(new Date()).format('YYYY-MM-DD HH:mm')}</p>
                </div>
            </div>
        </Modal>
    )
}
